/**
 * @desc 消息提示
 */

import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel, BasesController } from '../bases';
import { onCreateFactoryUser } from '../system/userModel';

@BindAll()
export class NoticeController<T = any> extends BasesController<T> {
  Model = new BaseModel({ type: 'object' });

  /**
   * 用户信息
   * @memberof SystemController
   */
  readonly User = onCreateFactoryUser();

  @computed
  get count() {
    return lodash.get(this.Model.value, 'count', null);
  }

  async getMsgCount(param, isPc = false) {
    let res: any = await AjaxBasics.request(
      lodash.assign(EnumAPI.bffsvr_notificationPage_list, {
        body: { ...param },
      }),
    );
    let count = 0;
    if (!isPc && (this.User.isISG || this.User.isIntendedISG)) {
      lodash.mapValues(res, (num: number) => {
        count += num;
      });
    } else {
      count = lodash.get(res, '0', 0);
    }
    this.Model.merge({ count });
    return res;
  }
}
